import { render } from "./PromotionsSlim.vue?vue&type=template&id=a0547fc2&scoped=true"
import script from "./PromotionsSlim.vue?vue&type=script&lang=js"
export * from "./PromotionsSlim.vue?vue&type=script&lang=js"

import "./PromotionsSlim.vue?vue&type=style&index=0&id=a0547fc2&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\dish-frontend-web-site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0547fc2"]])

export default __exports__